import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "https://code.visualstudio.com/"
        }}>{`Visual Studio Code`}</a>{`. In the command palette, run: `}<inlineCode parentName="li">{`MCP: Open User Configuration`}</inlineCode>{` to open the configuration file`}</li>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`mcp.json`}</inlineCode>{` with the following configuration:`}</li>
    </ol>
    <MCPConfigSnippet variant="vscode" mdxType="MCPConfigSnippet" />
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol"><strong parentName="li">{`Save`}</strong>{` the configuration file`}</li>
      <li parentName="ol">{`The MCP server will now be available the next time you chat with Copilot`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      